<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Mission</h4>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Type</label>
            <select class="form-control" [(ngModel)]="type">
              @for (t of missionTypes; track t[1]) {
                <option [ngValue]="t[1]">{{ t[0] }}</option>
              }
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Start Date</label>
            <input class="form-control" [(ngModel)]="startDate" type="datetime-local">
          </div>
          <div class="col-sm-6">
            <label>End Date</label>
            <input class="form-control" [(ngModel)]="endDate" type="datetime-local">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-4">
            <label>Complete Quantity</label>
            <input class="form-control" [(ngModel)]="completeQuantity" type="number" min="0">
          </div>
          <div class="col-sm-4">
            <label>Points Reward</label>
            <input class="form-control" [(ngModel)]="pointsReward" type="number" min="0">
          </div>
          <div class="col-sm-4">
            <label>Custom Param</label>
            <input class="form-control" [(ngModel)]="customParam" type="number" min="0">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>
